import React from 'react'
import HysteresisFieldSetWithWeekDayCard from './HysteresisFieldSetWithWeekDayCard'
import HysteresisFieldSetWithoutWeekDayCard from './HysteresisFieldSetWithoutWeekDayCard'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { StorageSoftwareVersion } from 'src/Libs/wallboxes/types'
import { isVersionGreaterThanOrEqualTo } from 'src/Libs/wallboxes/utils'
import useActiveInstallationContext from 'src/Libs/installations/hooks/use-active-installation-context'

interface Props {
  model: WallboxConfigurationModel
  displayCapacity?: boolean
  displayBidiMode?: boolean
  disabled?: boolean
}

/**
 *  Display Hysteresis Field set for wallbox settings depending on the software version
 */
const HysteresisFieldSet: React.FC<Props> = ({ model, displayCapacity = false, displayBidiMode = false, disabled = false }) => {
  const { storage } = useActiveInstallationContext()

  const softwareVersion = storage?.softwareRelease
  const isNewLayout = softwareVersion ? isVersionGreaterThanOrEqualTo(softwareVersion, StorageSoftwareVersion.X_2024_04) : false

  if (isNewLayout)
    return <HysteresisFieldSetWithWeekDayCard model={model} displayCapacity={displayCapacity} displayBidiMode={displayBidiMode} disabled={disabled} />

  return (
    <HysteresisFieldSetWithoutWeekDayCard model={model} displayCapacity={displayCapacity} displayBidiMode={displayBidiMode} disabled={disabled} />
  )
}

export default HysteresisFieldSet
